// Preview-only downloads for the unverified free-mail trial cohort (ENG-5237).
// The server 402s GET /api/deliverables/{id}/download (and the per-version
// download) with `{ reason: "verify_to_download" }` while a trial is
// seed-funded only on a consumer domain. There is no extra flag: the lock
// is a read of plan + signup domain + funded state, so every ENG-5229
// unlock path clears it. Web deploys ahead of the API, so a missing
// `download_locked` field must read as unlocked.

export const VERIFY_TO_DOWNLOAD_COPY =
  "Verify a work email or add a card to download";

export const VERIFY_TO_DOWNLOAD_REASON = "verify_to_download";

/** Path of the ENG-5229 unlock surface (card-on-file + billing copy). */
export const DOWNLOAD_UNLOCK_PATH = "/settings/billing";

export function isDownloadLocked(
  plan: { download_locked?: boolean | null } | null | undefined,
): boolean {
  return plan?.download_locked === true;
}

/** True when a 402 body is the download lock, including FastAPI's
 * `{ detail: { reason } }` wrap if a future revision uses HTTPException. */
export function isVerifyToDownloadBody(body: unknown): boolean {
  if (body == null || typeof body !== "object") return false;
  const rec = body as Record<string, unknown>;
  if (rec.reason === VERIFY_TO_DOWNLOAD_REASON) return true;
  const detail = rec.detail;
  if (detail && typeof detail === "object") {
    return (detail as Record<string, unknown>).reason === VERIFY_TO_DOWNLOAD_REASON;
  }
  return false;
}
